import { Body1, Body2 } from "@material/react-typography";
import React from "react";
import Button from "~/components/button";
import styled from "@emotion/styled";

const Caption = styled(Body2)`
  margin: 0;
`;

const PathContainer = styled("div")`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Wrapper = styled("div")`
  margin-bottom: 1rem;
`;

type CopyFolderPathDisplayProps = {
  currentPath: string;
  targetPath: string;
};

export const CopyFolderPathDisplay: React.FC<CopyFolderPathDisplayProps> = ({
  currentPath,
  targetPath,
}) => {
  const handleClick = (text: string) => {
    void navigator.clipboard.writeText(text);
  };

  return (
    <Wrapper>
      <PathDisplay
        pathType={"Current path"}
        path={currentPath}
        handleClick={handleClick}
      />
      <PathDisplay
        pathType={"Target path"}
        path={targetPath}
        handleClick={handleClick}
      />
    </Wrapper>
  );
};

type PathDisplayProps = {
  pathType: string;
  path: string;
  handleClick: (text: string) => void;
};
const PathDisplay: React.FC<PathDisplayProps> = ({
  pathType,
  path,
  handleClick,
}) => {
  return (
    <>
      <Caption>{pathType}</Caption>
      <PathContainer>
        <Body1>{path}</Body1>
        <Button
          icon="content_copy"
          onClick={() => handleClick(path)}
          title={"Copy path to clipboard"}
        />
      </PathContainer>
    </>
  );
};
